import Model from '@/class/cargo/model/utils/Model'

class HeadwayTail {
  constructor(code, chineseName, englishName) {
    this.code = code
    this.chineseName = chineseName
    this.englishName = englishName
  }
}

export const CODE_NAME = 'HeadwayTail'
export const HEADWAY = new HeadwayTail('HEADWAY', '头程', 'Headway')
export const TAILWAY = new HeadwayTail('TAILWAY', '尾程', 'Tailway')
export const TYPES = [HEADWAY, TAILWAY]

/**
 * return null:没找到.
 */
export function getHeadwayTailByCode(code) {
  return Model.getObjByCode(code, TYPES)
}

/**
 * return null:没找到.
 */
export function getHeadwayTailByBusType(code, arrs) {
  return Model.getObjByCode(code, arrs)
}
